import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import '../productParallax/prodParallaxTrial.css';
import { EquipmentProduct } from "../../types";

gsap.registerPlugin(ScrollTrigger);

interface EquipmentProductsProps {
  equipmentProducts: EquipmentProduct[];
  equipmentImage?: string;
  wrapperWidth?: string;
  wrapperMaxWidth?: string;
}

const ProductParallaxTrial: React.FC<EquipmentProductsProps> = ({
  equipmentProducts,
  equipmentImage,
  wrapperWidth = '100%',
  wrapperMaxWidth = '100%',
}) => {

  return (

      <>
        <h3>Equipment</h3>
        <ul>
          {equipmentProducts.map((equipmentProduct, index) => (
            <li key={index} className={`grid__img-container pos-${index + 1}`}>
                <div className="shopImg">
                  <img
                    src={
                      typeof equipmentProduct.image === 'string'
                        ? equipmentProduct.image
                        : equipmentProduct.image instanceof File
                        ? URL.createObjectURL(equipmentProduct.image)
                        : ''
                    }
                    alt={`Product ${index + 1}`}
                    className="grid__img"
                  />
                </div>
                <button className="arrowBtn" onClick={()=>{window.open(`${equipmentProduct.link}`, '_blank')}}>{equipmentProduct.name}</button>
            </li>
          ))}
        </ul>
      </>
    
  );
};

export default ProductParallaxTrial;
